var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2600",
    "data-name": "Group 2600",
    transform: "translate(-999 -1611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2574",
    "data-name": "Group 2574"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_325",
    "data-name": "Ellipse 325",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(999 1611)",
    fill: "#f7d600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2518",
    "data-name": "Group 2518",
    transform: "translate(265.767 -599.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    d: "M440.008,99.642a4.944,4.944,0,1,0-4.944-4.944A4.945,4.945,0,0,0,440.008,99.642Z",
    transform: "translate(343.945 2139.246)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M352.705,296.091a3.318,3.318,0,0,1,2.635,3.88l-1.971,10.316a3.317,3.317,0,0,1-6.516-1.245l1.971-10.316a3.318,3.318,0,0,1,3.88-2.635Z",
    transform: "translate(423.627 1953.037)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M250.452,274.792a3.318,3.318,0,0,1,3.9-2.609l11.334,2.246a3.317,3.317,0,0,1-1.289,6.507l-11.334-2.245a3.318,3.318,0,0,1-2.609-3.9Z",
    transform: "translate(510.654 1974.623)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M260.861,178.251a4.658,4.658,0,0,1-.638,6.553l-8.2,6.745a4.656,4.656,0,0,1-5.916-7.191l8.2-6.745a4.658,4.658,0,0,1,6.553.638Z",
    transform: "translate(516.049 2060.891)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3405",
    "data-name": "Path 3405",
    d: "M352.705,296.091a3.318,3.318,0,0,1,2.635,3.88l-1.971,10.316a3.317,3.317,0,0,1-6.516-1.245l1.971-10.316a3.318,3.318,0,0,1,3.88-2.635Z",
    transform: "translate(423.627 1953.037)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M126.338,363.41l-9.326,4.033a3.317,3.317,0,0,0,2.633,6.089l10.6-4.586a3.318,3.318,0,0,0,1.728-4.361q-.04-.094-.086-.184Z",
    transform: "translate(632.859 1892.214)",
    fill: "#002e5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M366.562,179.86c.866-.836,2.535-.515,3.724.716l15.971,16.542c1.189,1.231,1.451,2.91.585,3.747s-2.535.516-3.724-.716l-15.971-16.542c-1.189-1.232-1.451-2.91-.585-3.747Z",
    transform: "translate(406.244 2058.326)",
    fill: "#002e5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.5a893bc80fadc3828925c986ec8f410a.svg";
export { ForwardRef as ReactComponent };